import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Body } from '@nerdwallet/react-typography';

const HeroNavTile = ({
  nav,
  IconComponent,
  iconColor,
  backgroundColor,
  url,
}) => (
  <a href={url} className="hero-nav__tile-container">
    <div className="hero-nav__tile">
      <div style={{ backgroundColor }} className="hero-nav__icon-container">
        <IconComponent
          color={iconColor}
          size={48}
          className={classNames([
            classes(['width-100', 'height-100', 'padding-all-1']),
          ])}
        />
      </div>
      <Body className="hero-nav__text">{nav}</Body>
    </div>
  </a>
);

HeroNavTile.propTypes = {
  nav: PropTypes.string,
  IconComponent: PropTypes.elementType,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  url: PropTypes.string,
};

HeroNavTile.displayName = 'HeroNavTile';

export default HeroNavTile;
